import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DocumentoApp } from '../../../../core/api/models/documentoApp.model';

import { saveAs } from 'file-saver';

import {
  ApiService,
  NotificationService,
  ROUTE_ANIMATIONS_ELEMENTS
} from '../../../../core/core.module';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { BottomSheetUploadDocumentoComponent } from './bottomSheetUploadDocumento/bottomSheetUploadDocumento.component';

@Component({
  selector: 'mydyn-documenti',
  templateUrl: './documenti.component.html',
  styleUrls: ['./documenti.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentiComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  appLoading = false;
  documenti: DocumentoApp[] = [];

  constructor(
    private route: ActivatedRoute,
    private apiService: ApiService,
    private cd: ChangeDetectorRef,
    private notificationService: NotificationService,
    private bottomSheet: MatBottomSheet
  ) {}

  ngOnInit() {
    this.appLoading = true;
    this.route.parent.params.subscribe((params) => {
      this.apiService
        .getDocumentiPraticaDaApp(+params['id'])
        .subscribe((response) => {
          if (response !== null) {
            this.documenti = [].concat(response);
          }
          this.appLoading = false;
          this.cd.detectChanges();
        });
    });
  }

  downloadDocumento(documento: DocumentoApp) {
    this.appLoading = true;
    this.apiService
      .downloadDocumentoBase64ByPK(documento.codice)
      .subscribe((response) => {
        if (response !== null) {
          const sliceSize = 512;
          let contentType: string;
          switch (response.charAt(0)) {
            case 'J': {
              contentType = 'application/pdf';
              break;
            }
            case '/': {
              contentType = 'image/jpeg';
              break;
            }
            case 'i': {
              contentType = 'image/png';
              break;
            }
            case 'R': {
              contentType = 'image/gif';
              break;
            }
            default: {
              this.notificationService.error(
                'Formato documento non supportato'
              );
              return;
            }
          }
          const byteCharacters = atob(response);
          const byteArrays = [];
          for (
            let offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
          ) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);
            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
              byteNumbers[i] = slice.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
          }

          const blob = new Blob(byteArrays, { type: contentType });
          saveAs(blob, documento.descrizione);
        } else {
          this.notificationService.error(
            'Errore durante il download del documento'
          );
        }
      });
    this.appLoading = false;
    this.cd.detectChanges();
  }

  openBottomSheetUploadDocumento(tipoDocumento: number) {
    this.route.parent.params.subscribe((params) => {
      this.bottomSheet
        .open(BottomSheetUploadDocumentoComponent, {
          data: { tipoDocumento: tipoDocumento, idPratica: +params['id'] }
        })
        .afterDismissed()
        .subscribe((result) => {
          if (result) {
            this.appLoading = true;
            this.cd.detectChanges();
            this.apiService
              .getDocumentiPraticaDaApp(+params['id'])
              .subscribe((response) => {
                if (response !== null) {
                  this.documenti = [].concat(response);
                }
                this.appLoading = false;
                this.cd.detectChanges();
              });
          }
        });
    });
  }
}
